import { Filter } from '../../../domain/Filter';

export default (filters: Filter[]): string[] => {
    const grouped = filters.reduce((result: {}, current: Filter) => {
        if (current.value === false) {
            return result;
        }
        if (!result[current.type]) {
            result[current.type] = [current.value];
        } else {
            result[current.type] = [...result[current.type], current.value];
        }
        return result;
    }, {});
    return Object.keys(grouped).reduce((result: [], key: string) => {
        return [...result, key + '=' + grouped[key]];
    }, []);
};



// WEBPACK FOOTER //
// ./src/application/products/epic/filtersToQueryParameters.ts